<template>
    <v-checkbox color="primary-dark" hide-details :label="get_label(choix_pack)" v-model="pack.selected"
        @change="$emit('onToggle')" :disabled="!is_selectionnable"
        :class="[!is_selectionnable ? 'line-through' : '']"></v-checkbox>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    props: ["item", "inscription"],
    name: 'CheckboxSelectionPack',
    data() {
        return {

        };
    },
    computed: {
        ...mapStores(useMainStore),
        pack() {
            return this.item;
        },
        is_selectionnable() {
            let count_matched = 0;
            const nb_courses_in_pack = this.pack.list_liaisons.length;
            for (let i = 0; i < this.pack.list_liaisons.length; i++) {
                const course_in_pack = this.pack.list_liaisons[i];
                const course = this.inscription.list_courses.get_course_by_id(course_in_pack.id_course);
                if (!course) return false;
                const course_selectionable = course.is_selectionnable(
                    this.mainStore.module.status,
                    this.mainStore.view_as_admin,
                    this.mainStore.inscription_as_admin,
                    this.mainStore.inscription_vip,
                    this.mainStore.module.courses,
                    this.mainStore.module.is_complet,
                    this.mainStore.bookingSystem?.groupe
                );
                if (!course_selectionable) return false;
                count_matched++;
            }
            if (count_matched < nb_courses_in_pack) return false;
            return true;
        }
    },
    methods: {
        get_label() {
            let label = this.pack.nom;
            label += " (";
            for (let i = 0; i < this.pack.list_liaisons.length; i++) {
                let course_in_pack = this.pack.list_liaisons[i];
                label += course_in_pack.nom_course;
                if (i < this.pack.list_liaisons.length - 1) {
                    label += " + ";
                }
            }
            label += ")";
            return label;
        }
    }
};
</script>

<style scoped></style>